// extracted by mini-css-extract-plugin
export var button = "_mp-0";